import React from 'react'
import { SurveyChartCardSkeleton } from '@diversioteam/diversio-ds'

import { ResultsSummaryCardSkeleton } from '../ResultsSummary/skeleton'
import * as S from '../results.styles'

export const ResultsSkeleton = () => {
    return (
        <S.ResultsWrapper data-testid="pulse-surveys-results-skeleton">
            <ResultsSummaryCardSkeleton />

            <SurveyChartCardSkeleton questionType="multiple_choice" />

            <SurveyChartCardSkeleton questionType="rating" chartType="bar" />

            <SurveyChartCardSkeleton questionType="checkbox" chartType="bar" />

            <SurveyChartCardSkeleton questionType="short_answer" />
        </S.ResultsWrapper>
    )
}
